export default __webpack_public_path__ + "static/media/gallery - amortentia_00.8f09e4ca.jpg";